import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class WellnessInsightsController extends Controller {
  @tracked accountCreationFeedbackActive = '';

  queryParams = [
    {
      accountCreationFeedbackActive: { as: 'decline_account', type: 'string' as const },
    },
  ];
}
